export default "__VITE_ASSET__1JOaPVYv__"